var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bill_addon clr" },
    [
      _c("standart", {
        key: "bill_addon",
        attrs: {
          title: "Рахунок",
          is_active_result: false,
          is_active_problem: false,
        },
      }),
      _vm._v(" "),
      _c("b-table", {
        attrs: {
          items: _vm.counterparty_items,
          fields: _vm.counterparty_fields,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(remove_class)",
            fn: function (row) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "icon-stack rem_doc",
                    class: { disable: _vm.can_dell },
                    on: {
                      click: function ($event) {
                        return _vm.dell_counterparty(row.index)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "base base-1 icon-stack-3x opacity-100 color-danger-600",
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "far fa-trash-alt icon-stack-1x opacity-100 color-white",
                    }),
                  ]
                ),
              ]
            },
          },
          {
            key: "cell(name)",
            fn: function (row) {
              return [_c("c_name", { attrs: { row: row.item } })]
            },
          },
          {
            key: "cell(edrpou)",
            fn: function (row) {
              return [_c("edrpou", { attrs: { row: row.item } })]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "outline-info" },
              on: { click: _vm.new_counterparty },
            },
            [_vm._v("Додати")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }